import { useColorMode, useColorStyle } from '@tonic-one/react';

const useATagStyle = (disabled?: boolean, textDecoration?: string) => {
  const [colorMode] = useColorMode();
  const hoverTextDecoration = textDecoration ? 'none' : 'underline';
  const activeTextDecoration = disabled ? 'none' : 'underline';
  const color = ({ light: 'blue:60', dark: 'blue:40' } as any)[colorMode];
  const hoverColor = ({ light: 'blue:50', dark: 'blue:40' } as any)[colorMode];
  const visitedColor = ({ light: 'purple:60', dark: 'purple:50' } as any)[
    colorMode
  ];
  const disabledColor = (
    { light: 'black:disabled', dark: 'white:disabled' } as any
  )[colorMode];

  return {
    color,
    cursor: 'pointer',
    textDecoration: textDecoration ?? 'none',
    display: 'inline-flex',
    alignItems: 'center',
    _disabled: {
      color: disabledColor,
      cursor: 'not-allowed',
    },
    _visited: {
      color: visitedColor,
    },
    _hover: {
      color: hoverColor,
      textDecoration: disabled ? textDecoration : hoverTextDecoration,
    },
    _active: {
      color: 'blue:60',
      textDecoration: textDecoration ?? activeTextDecoration,
    },
  };
};

const usePrimaryBoxStyle = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  return {
    color: colorStyle.color.primary,
    backgroundColor: colorStyle.background.primary,
  };
};

export { useATagStyle, usePrimaryBoxStyle };
